import { randomNumber } from '../../../../utilities'
import { InitiateIvConstants } from './initiateIv.constants'
import { IInitiateIvAction, IInitiateIvState } from './initiateIv.types'

export const initialInitiateIvState: IInitiateIvState = {
  site: null,
  sitePNNV: null,
  size: '',
  iVType: null,
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Initiate IV',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  initiateIvDefaults: null,
  nemsisCode: null,
}

export function initiateIvReducer(
  state: IInitiateIvState = initialInitiateIvState,
  action: IInitiateIvAction
): IInitiateIvState {
  switch (action.type) {
    case InitiateIvConstants.SET_SITE:
      return { ...state, site: action.site }
    case InitiateIvConstants.SET_SITE_PNNV:
      return { ...state, sitePNNV: action.sitePNNV }
    case InitiateIvConstants.SET_GAUGE:
      return { ...state, size: action.size }
    case InitiateIvConstants.SET_TYPE:
      return { ...state, iVType: action.iVType }
    case InitiateIvConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case InitiateIvConstants.SET_DATE:
      return { ...state, date: action.date }
    case InitiateIvConstants.SET_TIME:
      return { ...state, time: action.time }
    case InitiateIvConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case InitiateIvConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case InitiateIvConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case InitiateIvConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case InitiateIvConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case InitiateIvConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case InitiateIvConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case InitiateIvConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case InitiateIvConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case InitiateIvConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case InitiateIvConstants.SET_STATE:
      return { ...action.initiateIvState, updateInputRows: true }
    case InitiateIvConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case InitiateIvConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case InitiateIvConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case InitiateIvConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case InitiateIvConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case InitiateIvConstants.SET_INITIATE_IV_DEFAULTS:
      return { ...state, initiateIvDefaults: action.initiateIvDefaults }
    case InitiateIvConstants.RESET_STATE:
      return {
        site: null,
        sitePNNV: null,
        size: '',
        iVType: null,
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Initiate IV',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        initiateIvDefaults: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
